import { Toast } from '../components';
import { useIzteachSessionStore } from '../stores/izteach';
import { msg } from '../i18n/msg';

// SSO failed but the QLT session is fine: say so without blocking anything. IZ screens keep their own signed-out state.
export function IzteachSsoNotice() {
  const failure = useIzteachSessionStore((state) => state.ssoFailure);
  const retry = useIzteachSessionStore((state) => state.signInWithQlt);
  const dismiss = useIzteachSessionStore((state) => state.dismissSsoFailure);
  if (!failure) return null;
  return (
    <Toast
      open={true}
      kind="warning"
      duration={0}
      message={msg('login:sso.failed', { message: failure.message })}
      // a missing link is fixed by an admin, not by trying again
      onRetry={failure.needsLink ? undefined : () => { void retry(); }}
      onClose={dismiss}
    />
  );
}

export default IzteachSsoNotice;
